export const serviceScheduleSchema = {
	title: "Service Schedule",
	type: "object",
	required: ["serviceDetails", "scheduleVariableFlexible"],
	properties: {
		serviceDetails: {
			type: "object",
			title: "Service Details",
			description: "Select your desired start date and any special requests",
			required: ["startDate", "caregiverPreference"],
			properties: {
				startDate: {
					type: "string",
					title: "Select your desired start date",
					format: "date",
					errorMessage: {
						required: "Desired start date is required",
						format: "Desired start date is required",
					},
				},
				caregiverPreference: {
					type: "string",
					title: "Caregiver Preference",
					enum: ["Male", "Female", "No Preference"],
					minLength: 1,
					errorMessage: {
						required: "Please select a caregiver preference",
						minLength: "Please select a caregiver preference",
					},
				},


				specialRequests: {
					type: "string",
					title: "Special Requests",
					maxLength: 500,
					errorMessage: {
						maxLength: "Special requests must be 500 characters or less",
					},
				},
			},
		},
		scheduleVariableFlexible: {
			type: "object",
			title: "Schedule: Variable and Flexible",
			description: "Select the days and times you need care services",
			required: ["scheduleType", "dayTimes"],
			properties: {
				scheduleType: {
					type: "string",
					title: "Select Schedule Type",
					enum: [
						"24/7 Round-the-Clock Care",
						"Live-in Care",
						"Custom",
					],
					minLength: 1,
					errorMessage: {
						required: "Please select schedule type",
						minLength: "Please select schedule type",
					},
				},
				dayTimes: {
					type: "object",
					title: "Daily Schedule",
					properties: {
						Monday: {
							type: "object",
							required: ["startTime", "endTime"],
							properties: {
								startTime: {
									type: "string",
									format: "time",
									title: "Start Time",
									errorMessage: {
										required: "Start time must be in HH:mm format",
										format: "Start time must be a valid time (HH:MM)",
									},
								},
								endTime: {
									type: "string",
									format: "time",
									title: "End Time",
									errorMessage: {
										required: "End time must be in HH:mm format",
										format: "End time must be a valid time (HH:MM)",
									},
								},
							},
						},
						Tuesday: {
							type: "object",
							required: ["startTime", "endTime"],
							properties: {
								startTime: {
									type: "string",
									format: "time",
									title: "Start Time",
									errorMessage: {
										required: "Start time must be in HH:mm format",
										format: "Start time must be a valid time (HH:MM)",
									},
								},
								endTime: {
									type: "string",
									format: "time",
									title: "End Time",
									errorMessage: {
										required: "End time must be in HH:mm format",
										format: "End time must be a valid time (HH:MM)",
									},
								},
							},
						},
						Wednesday: {
							type: "object",
							required: ["startTime", "endTime"],
							properties: {
								startTime: {
									type: "string",
									format: "time",
									title: "Start Time",
									errorMessage: {
										required: "Start time must be in HH:mm format",
										format: "Start time must be a valid time (HH:MM)",
									},
								},
								endTime: {
									type: "string",
									format: "time",
									title: "End Time",
									errorMessage: {
										required: " End time must be in HH:mm format",
										format: "End time must be a valid time (HH:MM)",
									},
								},
							},
						},
						Thursday: {
							type: "object",
							required: ["startTime", "endTime"],
							properties: {
								startTime: {
									type: "string",
									format: "time",
									title: "Start Time",
									errorMessage: {
										required: "Start time must be in HH:mm format",
										format: "Start time must be a valid time (HH:MM)",
									},
								},
								endTime: {
									type: "string",
									format: "time",
									title: "End Time",
									errorMessage: {
										required: "End time must be in HH:mm format",
										format: "End time must be a valid time (HH:MM)",
									},
								},
							},
						},
						Friday: {
							type: "object",
							required: ["startTime", "endTime"],
							properties: {
								startTime: {
									type: "string",
									format: "time",
									title: "Start Time",
									errorMessage: {
										required: "Start time must be in HH:mm format",
										format: "Start time must be a valid time (HH:MM)",
									},
								},
								endTime: {
									type: "string",
									format: "time",
									title: "End Time",
									errorMessage: {
										required: "End time must be in HH:mm format",
										format: "End time must be a valid time (HH:MM)",
									},
								},
							},
						},
						Saturday: {
							type: "object",
							required: ["startTime", "endTime"],
							properties: {
								startTime: {
									type: "string",
									format: "time",
									title: "Start Time",
									errorMessage: {
										required: "Start time must be in HH:mm format",
										format: "Start time must be a valid time (HH:MM)",
									},
								},
								endTime: {
									type: "string",
									format: "time",
									title: "End Time",
									errorMessage: {
										required: "End time must be in HH:mm format",
										format: "End time must be a valid time (HH:MM)",
									},
								},
							},
						},
						Sunday: {
							type: "object",
							required: ["startTime", "endTime"],
							properties: {
								startTime: {
									type: "string",
									format: "time",
									title: "Start Time",
									errorMessage: {
										required: "Start time must be in HH:mm format",
										format: "Start time must be a valid time (HH:MM)",
									},
								},
								endTime: {
									type: "string",
									format: "time",
									title: "End Time",
									errorMessage: {
										required: "End time must be in HH:mm format",
										format: "End time must be a valid time (HH:MM)",
									},
								},
							},
						},
					},
				},
				showTimes: {
					type: "boolean",
					default: false,
				},
			},
		},
	},
};
export const serviceScheduleUiSchema = {
	serviceDetails: {
		startDate: {
			"ui:md": 6, "ui:widget": "DateWidget",
			"ui:options": {
				disablePast: true
			}
		},

		caregiverPreference: { "ui:md": 6 },

		specialRequests: { "ui:md": 12, "ui:widget": "TextareaAutosizeWidget", "ui:placeholder": "Enter any special care requirements or requests..", "ui:options": {     rows: 3,
    maxRows: 6, } },
	},
	scheduleVariableFlexible: {
		scheduleType: { "ui:widget": "select", "ui:md": 6, "ui:placeholder": "Select Schedule Type" },
		days: { "ui:widget": "checkboxes", "ui:md": 12, "ui:options": { inline: true } },
		dayTimes: {
			"ui:field": "ScheduleTimesWidget",
			"ui:md": 12,
		},
		showTimes: { "ui:widget": "hidden" },
	},
};